import useRequest from '@/websdk/utils/request';

export default function () {
  const { data, exec } = useRequest({
    url: '/api/pigments',
    name: 'GET_PIGMENTS',
  });

  return [data || [], exec];
}
